import { initDropdown } from "./dropdown";

const submitForm = () => {
  const form = document.getElementById("contact-form");

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    document.getElementById("contact-container").innerHTML =
      "<h1>We will reach out to you</h1>";
  });
};

const main = () => {
  submitForm();
  initDropdown(document.querySelector(".links"));
};

if (document.readyState === "interactive") {
  main();
} else {
  window.addEventListener("DOMContentLoaded", (event) => {
    main();
  });
}
